import type { AdminReportStatus, FieldReadiness } from '@cer-autofill/shared';
import {
  readinessLabel,
  readinessPillClass,
  readinessTitle,
  statusLabel,
  statusPillClass,
} from '../format.js';

export function StatusPill({
  status,
  portalApprovedAt,
}: {
  status: AdminReportStatus;
  portalApprovedAt?: string | undefined;
}) {
  return (
    <span className={statusPillClass(status)}>
      {status === 'approved' && portalApprovedAt ? 'Approved for portal' : statusLabel(status)}
    </span>
  );
}

/**
 * How many checks are still outstanding — needs-work vs ready-for-QA. Sits
 * beside StatusPill, which says something different: where the report writer
 * has since taken it.
 */
export function ReadinessPill({ readiness }: { readiness: FieldReadiness }) {
  return (
    <span className={readinessPillClass(readiness)} title={readinessTitle(readiness)}>
      {readinessLabel(readiness)}
    </span>
  );
}

export function ClauseCounts({
  counts,
}: {
  counts: { compliant: number; nonCompliant: number; notApplicable: number };
}) {
  return (
    <span className="clause-counts" aria-label="Clause outcome counts">
      <span className="clause-count clause-count--c" title="Compliant">
        C {counts.compliant}
      </span>
      <span className="clause-count clause-count--nc" title="Non-compliant">
        NC {counts.nonCompliant}
      </span>
      <span className="clause-count clause-count--na" title="Not applicable">
        N/A {counts.notApplicable}
      </span>
    </span>
  );
}
